class CustomSelect {

    constructor(init = true) {
        if (init) {
            this._open    = false;
            this._selects = Array.prototype.slice.call(document.getElementsByTagName("select"));
            this._active  = null;
            this._current = null;
            this._search = null;
            this._interval = 0;

            for (let i = 0; i < this._selects.length; i++) {
                this._createStructure(this._selects[i]);
            }
        }
    }

    /**
     *
     * @param {string} id
     */
    refresh(id) {
        const select              = document.getElementById(id);
        const options             = select.getElementsByTagName("option");
        let optionContainer       = document.querySelector(`#${id} + .custom-select-panel`);

        select.previousElementSibling.innerHTML = '<span>' + select.options[0].text + '</span>';
        select.selectedIndex = 0;
        optionContainer.innerHTML = "";
        this._createOption(options, optionContainer);
    }

    /**
     *
     * @param {Element} select
     * @private
     */
    _createStructure(select) {
        const options = select.getElementsByTagName("option");

        // Create parent node with this attribute
        let parentDiv = document.createElement("div");
        parentDiv.classList.add('custom-select-container');
        parentDiv.classList.add('custom-select');

        // Create select box
        let spanOpener = document.createElement("span");
        spanOpener.classList.add("custom-select-opener");
        spanOpener.setAttribute("tabindex", "0");

        // Create text of select box
        let optionShow       = document.createElement("span");
        optionShow.innerHTML = options[0].innerHTML;

        // Create option's container
        let optionContainer = document.createElement("div");
        optionContainer.classList.add('custom-select-panel');

        const CLASS_LIST = Array.prototype.slice.call(select.classList);
        let container = optionContainer;

        if (CLASS_LIST.length > 0) {
            const div = document.createElement('div');
            for (let i = 0; i < CLASS_LIST.length; i++) {
                optionContainer.classList.add(CLASS_LIST[i]);

            }

            optionContainer.appendChild(div);
            container = div;
        }


        // Create option
        const optionsCreated = this._createOption(options, container);

        // Insert all element create in DOM
        select.parentNode.insertBefore(parentDiv, select);
        spanOpener.appendChild(optionShow);
        parentDiv.appendChild(spanOpener);
        parentDiv.appendChild(select);
        parentDiv.appendChild(optionContainer);

        if (optionsCreated !== null) {
            this._setSelectedOption(optionsCreated);
        }

        // Add listner
        parentDiv.addEventListener("click", (e) => this._toggleSelect(e.target));
        window.addEventListener("click", () => this._closeSelect(parentDiv));
        parentDiv.addEventListener("keydown", (e) => this._keyListner(e, optionContainer.childNodes));
    }

    /**
     *
     * @param {NodeListOf<HTMLOptionElement>} options
     * @param {Element} optionContainer
     * @return {HTMLElement}
     * @private
     */
    _createOption(options, optionContainer) {
        let optionSelected = null;

        /**
         * Create a div for each option
         */
        for (let i = 0; i < options.length; i++) {
            if ((options[i].value !== "" && options[i].value !== undefined) || (options[i].hasAttribute('data-show') && options[i].getAttribute('data-show') === 'true')) {
                let option = document.createElement("div");
                option.classList.add("custom-select-option");

                if (i === 0) {
                    option.classList.add("is-active");
                }

                // Save option if selected
                if (options[i].hasAttribute('selected')) {
                    optionSelected = option;
                }

                // Add is value and add focusable
                option.setAttribute("data-value", options[i].value);
                option.setAttribute("tabindex", "-1");
                option.innerHTML = options[i].innerHTML;

                optionContainer.appendChild(option);

                // Add listner
                option.addEventListener("click", () => this._setSelectedOption(option));
            }
        }

        return optionSelected;
    }

    /**
     *
     * @param {HTMLElement} element
     * @private
     */
    _openSelect(element) {
        element.classList.add("is-open");
        this._search = "";
        setTimeout(() => {
            this._open    = true;
            this._current  = element;
            this._interval = setInterval(() => {
                this._search = "";
            }, 1000);
        }, 100);
    }

    /**
     *
     * @param {HTMLElement|Node} element
     * @private
     */
    _closeSelect(element) {
        if (this._open && element === this._current) {
            element.classList.remove("is-open");
            this._open   = false;
            this._current = null;
            clearInterval(this._interval);
        }
    }

    /**
     *
     * @param {Element|EventTarget} element
     * @private
     */
    _toggleSelect(element) {
        if (!element.classList.contains("custom-select-option")) {
            if (element.classList.contains("custom-select-container")) {
                this._toggle(element);
            }
            else {
                if (element.parentElement.classList.contains("custom-select-container")) {
                    this._toggle(element.parentElement);
                }
                else {
                    this._toggle(element.parentElement.parentElement);
                }
            }
        }
    }

    /**
     *
     * @param {HTMLElement|Element|EventTarget} element
     * @private
     */
    _toggle(element) {
        if (element.classList.contains("is-open")) {
            this._closeSelect(element);
        }
        else {
            this._openSelect(element);
        }
    }

    /**
     *
     * @param {HTMLElement} option
     * @private
     */
    _setSelectedOption(option) {

        let select;
        let span;
        if (option.parentElement.parentElement.classList.contains('custom-select-container')) {
            select = option.parentElement.previousElementSibling;
            span   = option.parentElement.previousElementSibling.previousElementSibling.children[0];
        } else {
            select = option.parentElement.parentElement.previousElementSibling;
            span   = option.parentElement.parentElement.previousElementSibling.previousElementSibling.children[0];
        }

        span.innerHTML = option.innerHTML;
        span.classList.add("selected");

        select.value = option.getAttribute("data-value");

        for (let i = 0; i < option.parentNode.childNodes.length; i++) {
            option.parentNode.childNodes[i].classList.remove("is-active");
        }
        option.classList.add("is-active");
        this._active = option;


        this._closeSelect(option.parentNode.parentNode);
    }

    /**
     *
     * @param {KeyboardEvent|Event} e
     * @param {NodeListOf<Node>} options
     * @private
     */
    _keyListner(e, options) {
        if (e.srcElement.classList.contains("custom-select-option")) {
            if (e.key === "ArrowUp" || e.code === "ArrowUp") {
                e.preventDefault();
                e.stopPropagation();
                if (e.srcElement === options[0]) {
                    options[options.length - 1].focus();
                }
                else {
                    const previousElement = e.srcElement.previousElementSibling;
                    previousElement.focus();
                }
            }
            else if (e.key === "ArrowDown" || e.code === "ArrowDown") {
                e.preventDefault();
                e.stopPropagation();
                if (e.srcElement === options[options.length - 1]) {
                    options[0].focus();
                }
                else {
                    const nextElement = e.srcElement.nextElementSibling;
                    nextElement.focus();
                }
            }
            else if (e.key === "Enter" || e.code === "Enter" || e.code === "NumpadEnter") {
                e.srcElement.click();
            }
            else {
                this._searchOption(e, options);
            }
        }
        else {
            if (e.key === "ArrowUp" || e.code === "ArrowUp") {
                e.preventDefault();
                e.stopPropagation();
                if (this._active !== null) {
                    let index = Array.prototype.slice.call(options).indexOf(this._active) - 1;
                    index     = index < 0 ? options.length - 1 : index;
                    options[index].focus();
                }
                else {
                    options[options.length - 1].focus();
                }
            }
            else if (e.key === "ArrowDown" || e.code === "ArrowDown") {
                e.preventDefault();
                e.stopPropagation();
                if (this._active !== null) {
                    let index = Array.prototype.slice.call(options).indexOf(this._active) + 1;
                    index     = index >= options.length ? 0 : index;
                    options[index].focus();
                }
                else {
                    options[0].focus();
                }
            }
            else {
                this._searchOption(e, options);
            }
        }
    }

    /**
     *
     * @param {KeyboardEvent} e
     * @param {NodeListOf<Node>} options
     * @private
     */
    _searchOption(e, options) {
        this._search += e.key;
        let option = null;
        for (let i = 0; i < options.length; i++) {
            const regex = new RegExp("^" + this._search, "i");
            if (options[i].innerHTML.match(regex)) {
                option = options[i];
                break;
            }
        }
        if (option !== null) {
            option.focus();
        }
    }
}